// Ambassador related sagas

import { put, select } from 'redux-saga/effects';

// Services
import { ErrorCategory, handleError } from '@services/errorService';

// Api
import client from '@api';

// Actions
import { UpdateMarkup, UpdatedMarbleUser } from '@actions/user';
import { SetLoading } from '@actions/loading';
import { SetRedirectControl } from '@actions/redirectControl';

// Graph
import { updateAmbasadorSettings } from '@graphql/mutations/account';

// Types
import type { PayloadAction, UpdateAmbasadorPayload } from './types';

export function* UpdateAmbasadorSaga({
  payload,
}: PayloadAction<UpdateAmbasadorPayload>): Generator {
  try {
    yield put(SetLoading(true));
    const { isOnboardingPassed, username } = (yield select(
      (state: { User: { onboardingPassed: boolean; username: string } }) => ({
        isOnboardingPassed: !!state.User.onboardingPassed,
        username: state.User?.username,
      }),
    )) as {
      isOnboardingPassed: boolean;
      username: string;
    };

    const {
      data: {
        updateAmbasadorSettings: { backgroundSettings, ambassadorEnabled },
      },
    } = (yield client().mutate({
      mutation: updateAmbasadorSettings,
      variables: {
        input: { ...payload },
      },
    })) as {
      data: {
        updateAmbasadorSettings: {
          backgroundSettings: { markup: string };
          ambassadorEnabled: boolean;
        };
      };
    };

    yield put(UpdateMarkup(backgroundSettings?.markup));
    yield put(
      UpdatedMarbleUser({
        ambassadorEnabled,
      }),
    );

    if (isOnboardingPassed) {
      yield put(SetRedirectControl(`/${username}`));
    } else {
      yield put(SetRedirectControl('/onboarding/profile'));
    }
    yield put(SetLoading(false));
  } catch (e) {
    handleError(e, { category: ErrorCategory.API });
    yield put(SetLoading(false));
  }
}
